import { FC, useMemo } from "react";
import TableComponent, {
  TableProps,
} from "../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../context/app.context";
import OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableRow from "../types/order-optimizer-taxi-details-hidden-details-center-tables-driver-table-row";
import orderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableHelper from "./order-optimizer-taxi-details-hidden-details-heading-tables-driver-table.helper";
import { OrderOptimizerTaxiDetailsItemStepsOrdersPoints } from "../../../common/types/order-optimizer-taxi-details-item";
import orderOptimizerTaxiDetailsHelper from "../../../order-optimizer-taxi-details.helper";

type OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  detailsStepsOrdersPointsItems: OrderOptimizerTaxiDetailsItemStepsOrdersPoints[];
};

const OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsOrdersPointsItem: OrderOptimizerTaxiDetailsItemStepsOrdersPoints
  ): OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableRow => {
    const driverTimeLabel = orderOptimizerTaxiDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.driverTime
    );
    const driverTimeTitle = orderOptimizerTaxiDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.driverTime
    );

    const driverDistanceLabel =
      orderOptimizerTaxiDetailsHelper.getDistanceLabel(
        detailsStepsOrdersPointsItem.driverDistance
      );
    const driverDistanceTitle =
      orderOptimizerTaxiDetailsHelper.getDistanceLabel(
        detailsStepsOrdersPointsItem.driverDistance
      );

    const driverDrivingTimeLabel =
      orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverDrivingTime
      );
    const driverDrivingTimeTitle =
      orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverDrivingTime
      );

    const driverHaltingTimeLabel =
      orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverHaltingTime
      );
    const driverHaltingTimeTitle =
      orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverHaltingTime
      );

    return {
      id: uuidService.generate(),
      value: {
        driverTime: <div title={driverTimeTitle}>{driverTimeLabel}</div>,
        driverDistance: (
          <div title={driverDistanceTitle}>{driverDistanceLabel}</div>
        ),
        driverDrivingTime: (
          <div title={driverDrivingTimeTitle!}>{driverDrivingTimeLabel}</div>
        ),
        driverHaltingTime: (
          <div title={driverHaltingTimeTitle!}>{driverHaltingTimeLabel}</div>
        ),
      },
    };
  };

  const rows: OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableRow[] =
    useMemo(() => {
      return props.detailsStepsOrdersPointsItems.map(createTableRow);
    }, [props.detailsStepsOrdersPointsItems, selectedAppLanguage]);
  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesDriverTableComponent;
